import { AbstractSearchCriteria } from './abstract-search-criteria';
import { KeyControlAndAbstractSearchCriteria } from './key-control-and-abstract-search-criteria';

export class CompanySearchCriteria extends KeyControlAndAbstractSearchCriteria {
    code: string = '';
    name: string = '';
}
